import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 top-0 my-auto h-2 w-full bg-blue-100" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "flex"
}
const _hoisted_5 = {
  key: 2,
  class: "relative"
}
const _hoisted_6 = {
  key: 3,
  class: "relative w-full"
}
const _hoisted_7 = {
  key: 4,
  class: "flex"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "bottom-0 top-0 my-auto -ml-1 h-2 w-2 rounded-full bg-blue-100" }, null, -1)
const _hoisted_9 = {
  key: 5,
  class: "border-l-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mode === 'whole')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_ctx.mode === 'in')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "bottom-0 top-0 my-auto h-2",
            style: _normalizeStyle(_ctx.classes[0])
          }, null, 4),
          _createElementVNode("div", {
            class: "bottom-0 top-0 my-auto h-2 bg-blue-100",
            style: _normalizeStyle(_ctx.classes[1])
          }, null, 4),
          _createElementVNode("div", {
            class: "bottom-0 top-0 my-auto h-2",
            style: _normalizeStyle(_ctx.classes[2])
          }, null, 4)
        ]))
      : (_ctx.mode === 'left')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "absolute bottom-0 top-0 my-auto h-2 bg-blue-100",
              style: _normalizeStyle(_ctx.classes)
            }, null, 4)
          ]))
        : (_ctx.mode === 'right')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "absolute bottom-0 top-0 right-0 my-auto h-2 bg-blue-100",
                style: _normalizeStyle(_ctx.classes)
              }, null, 4)
            ]))
          : (_ctx.mode === 'pin')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "bottom-0 top-0 my-auto h-2",
                  style: _normalizeStyle(_ctx.classes)
                }, null, 4),
                _hoisted_8
              ]))
            : (_ctx.mode === 'none')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : _createCommentVNode("", true)
}